import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import logo from "@/assets/logo-25segundos-horizontal.png"
import logoMetodo from "@/assets/logo-metodo.jpg"
import rafaelaImg from "@/assets/rafaela-nova.png"
import claudiaImg from "@/assets/claudia.png"
import pastaImg from "@/assets/pasta.png"
import { PageLayout } from "./PageLayout"

interface WelcomeProps {
  onStart: () => void
}

export function Welcome({ onStart }: WelcomeProps) {
  return (
    <PageLayout>
      <Card className="max-w-5xl w-full p-6 md:p-10 shadow-elegant">
        <div className="text-center space-y-5">
          <div className="flex justify-center">
            <img
              src={logo}
              alt="25 Segundos - Desenvolvimento e Treinamento"
              className="h-20 w-auto"
            />
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl md:text-4xl font-bold text-title-blue">
              ✧ ORIENTAÇÃO PROFISSIONAL 25SEGUNDOS ✧
            </h1>
            <div className="flex items-center justify-center gap-2">
              <img
                src={logoMetodo}
                alt="Método"
                className="w-12 h-12 object-contain rounded-full"
              />
              <p className="text-lg md:text-xl text-foreground font-medium">
                25Método S.E.M.E.A.R. + Eneagrama
              </p>
            </div>
            <p className="text-base md:text-lg text-muted-foreground">
              ⮕ Descubra sua inclinação profissional, sinta o seu propósito e planeje seu futuro.
            </p>
          </div>

          <div className="py-3">
            <h2 className="text-xl md:text-2xl font-bold text-title-blue mb-4">
              ✧ Idealizadoras do Método ✧
            </h2>

            <div className="grid gap-4 md:grid-cols-2 text-left">
              <Card className="p-4 bg-gradient-to-br from-primary/5 to-secondary/5 border-primary/20 hover-scale">
                <div className="space-y-2">
                  <div className="flex items-center justify-center gap-3">
                    <img
                      src={rafaelaImg}
                      alt="Rafaela Ferreira"
                      className="w-16 h-16 object-contain flex-shrink-0"
                    />
                    <img
                      src={pastaImg}
                      alt="Pasta"
                      className="w-12 h-12 object-contain flex-shrink-0"
                    />
                  </div>
                  <h3 className="font-bold text-base md:text-lg text-title-blue text-center">
                    ✺ Rafaela Ferreira
                  </h3>
                  <div className="space-y-0.5 text-xs md:text-sm text-muted-foreground">
                    <p>⮕ Criadora do 25Método S.E.M.E.A.R.</p>
                    <p>⮕ Co-Fundadora da 25Segundos</p>
                    <p>⮕ Gestora Pedagógica e Administrativa</p>
                    <p>⮕ Educadora, especialista em Gestão Emocional</p>
                    <p>⮕ Terapeuta em Análise Comportamental</p>
                  </div>
                </div>
              </Card>

              <Card className="p-4 bg-gradient-to-br from-secondary/5 to-accent/5 border-secondary/20 hover-scale">
                <div className="space-y-2">
                  <div className="flex items-center justify-center gap-3">
                    <img
                      src={claudiaImg}
                      alt="Maria Cláudia Lopes"
                      className="w-16 h-16 object-contain flex-shrink-0"
                    />
                    <img
                      src={pastaImg}
                      alt="Pasta"
                      className="w-12 h-12 object-contain flex-shrink-0"
                    />
                  </div>
                  <h3 className="font-bold text-base md:text-lg text-title-blue text-center">
                    ✺ Maria Cláudia Lopes
                  </h3>
                  <div className="space-y-0.5 text-xs md:text-sm text-muted-foreground">
                    <p>⮕ Criadora do 25Método S.E.M.E.A.R.</p>
                    <p>⮕ Co-Fundadora da 25Segundos</p>
                    <p>⮕ Pedagoga desde 2004</p>
                    <p>⮕ Atua em treinamentos profissionais</p>
                  </div>
                </div>
              </Card>
            </div>

            <p className="text-center text-accent font-medium mt-3 text-xs md:text-sm">
              ✧ Uma parceria que inspira escolas e transforma vidas ✧
            </p>
          </div>

          <Button
            onClick={onStart}
            size="lg"
            className="bg-gradient-primary hover:opacity-90 transition-opacity text-lg md:text-xl px-10 md:px-14 py-5 md:py-6 h-auto shadow-elegant hover-scale"
          >
            ⮕ Começar Teste
          </Button>
        </div>
      </Card>
    </PageLayout>
  )
}
